import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';

const Organizations = () => {
  const { t } = useTranslation();

  const organizations = [
    {
      key: 'fci',
      logo: 'https://www.fci.be/medias/FCI-LOC-BLUE-ECR-94aa6e67.png',
      website: 'https://www.fci.be/en/',
      color: 'blue'
    },
    {
      key: 'kif',
      logo: 'https://kif.org.tr/assets/img/logo.png',
      website: 'https://kif.org.tr/',
      color: 'green'
    },
    {
      key: 'sacc',
      logo: 'https://societaamatoricanecorso.it/wp-content/uploads/2019/01/logo-sacc-1.png',
      website: 'https://societaamatoricanecorso.it',
      color: 'red'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-12 text-gray-900">
          {t('organizations.title')}
        </h1>

        <div className="max-w-5xl mx-auto space-y-8">
          {organizations.map((org) => (
            <div
              key={org.key}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <div className="md:flex">
                <div className="md:w-1/3 bg-gray-100 flex items-center justify-center p-8">
                  <div className="w-full h-32 flex items-center justify-center">
                    <div className="text-6xl font-bold text-gray-400">
                      {org.key.toUpperCase()}
                    </div>
                  </div>
                </div>
                <div className="md:w-2/3 p-8">
                  <h2 className="text-2xl font-bold mb-4 text-gray-900">
                    {t(`organizations.${org.key}.name`)}
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    {t(`organizations.${org.key}.description`)}
                  </p>
                  <a
                    href={org.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors font-medium"
                  >
                    {t('organizations.visitWebsite')}
                    <ExternalLink size={18} className="ml-2" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto mt-12 p-8 bg-white rounded-lg shadow-lg">
          <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">
            Uluslararası İşbirliği
          </h2>
          <p className="text-gray-700 leading-relaxed text-center">
            Derneğimiz, FCI ve KIF standartlarına uygun çalışmalar yürütmekte olup, 
            SACC ile iş birliği içerisinde Cane Corso ırkının korunması ve geliştirilmesi 
            için çalışmaktadır. Uluslararası standartlara uygun soyağacı kayıtları tutulmakta 
            ve düzenli olarak etkinlikler düzenlenmektedir.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Organizations;
